import React from 'react';
import { NavLink } from 'react-router-dom';

import EditApplicationButton from 'Components/EditApplicationButton';

export default ({ applicationStatus, user, applicationId, loadInProgress }) => {
  const link = `/${user.getManufacturerCode()}/component/application/${applicationId}/edit`;

  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div
        className='go-back-to-list-header-button'
        onClick={() => {
          user.goToList(false);
        }}
      >
        Back
      </div>
      <header>Component Details</header>
      {!loadInProgress && (
        <React.Fragment>
          <NavLink to={link}>
            <EditApplicationButton />
          </NavLink>
          <div className={`detailsScene__status-label ${applicationStatus.toLowerCase()}`}>
            {applicationStatus.toLowerCase()}
          </div>
        </React.Fragment>
      )}
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Details/Header.jsx